module.exports = __webpack_public_path__ + "img/smooth-video.9f99c407.png";